import { render, staticRenderFns } from "./AssegnazioneAllieviAziendeTirEstivi.vue?vue&type=template&id=d3d25e8a&"
import script from "./AssegnazioneAllieviAziendeTirEstivi.vue?vue&type=script&lang=ts&"
export * from "./AssegnazioneAllieviAziendeTirEstivi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
